import React, { lazy } from "react";

const SearchCom = lazy(() => import("../../pages/Search/Search"));
const UnSubscribe = lazy(() => import("../../pages/UnSubscribe/UnSubscribe"));
const Chinesepage = lazy(() => import("../../components/common/Chinesepage"));
const SurveyPage = lazy(() => import("../../components/common/SurveyPage"));

const miscRoutes = [
  { path: "/search", element: <SearchCom />, title: "Page search" },
  { path: "/unsubscribe", element: <UnSubscribe /> },
  { path: "/education/glossaryCN", element: <Chinesepage /> },
  { path: "/SurveyPage", element: <SurveyPage /> },
];

export default miscRoutes;
